export function generateClickId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID().replace(/-/g, '');
    }

    let clickId = '';
    for (let i = 0; i < 32; i++) clickId += Math.floor(Math.random() * 16).toString(16);
    return clickId;
}

export function buildTrxId(campaignParameters = {}) {
    if (campaignParameters.transactionId) return campaignParameters.transactionId;

    const clickId = campaignParameters.clickId || generateClickId();
    const campaignId = campaignParameters.campaignId || '0';
    const trafficSource = campaignParameters.publisherId || '0';

    return `${clickId}-${campaignId}-${trafficSource}`;
}
